import { observable_component } from 'common/util/ComponentDecorator';

@observable_component
export default class yaShare2Link {
	static classname = 'ya-share2__link';

	constructor($link) {
		$link.attr('title', '');
	}
}
